// import { useCustomAuthStore } from "@/store/stores/customAuthStores.js";
import { useAuthAppStore } from "@/store/stores/authStore";
import { permissionEnum } from "@/constants/permissionEnum";
import { usePurchaseOrderStore } from "@/store/stores/purchaseOrderStore";
import { PermissionService } from "../permissionService/permissionService";
// headers: {
//   "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex
// },

export class PurchaseOrderService {
  async getAllEntitiesPaged({
    purchaseOrderServiceClient,
    params,
    status,
    departmentQuery,
    priority,
    assignedUser,
    terminal
  }) {
    var resp = this.getFiltersByUserPermissions(
      params,
      status,
      departmentQuery,
      priority,
      assignedUser,
      terminal
    );

    if (!resp.stopped) {
      var response = await purchaseOrderServiceClient.get({
        route: "/purchase-order/get-all-entities-paged",
        params: resp.params,
        headers: {
          "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
          Authorization: `Bearer ${useAuthAppStore().token}`,
        },
        successCallback: function (resp) {
          // if (resp.data.length > 0)
          //     _selectedJob.unitsOnTruck = resp.data;
        },
        errorCallback: function (resp) {},
      });

      return response;
    }
    return null;
  }

  getFiltersByUserPermissions(
    params,
    status,
    departmentQuery,
    priority,
    assignedUser,
    terminal
  ) {
    var stopped = false;

    // Mevcut filtre varsa çözümle
    let currentFilter = JSON.parse(params.filter || "[]");
    if (!Array.isArray(currentFilter)) {
      currentFilter = []; // Eğer bir dizi değilse boş bir dizi başlatıyoruz
    }

    // readALL yetkisine göre aksiyon
    const hasPOReadAllPermission = this.hasPOReadAllPermission();
    if (!hasPOReadAllPermission) {
      const userName = useAuthAppStore().getParsedToken?.userName;

      // if (currentFilter.length > 0) {
      //   currentFilter.push("and", ["UserName", "=", userName]);
      // } else {
      params.PurchaseRequestCreator = userName;
      // }
    }

    // ALL yetkisi varsa başka bir şeye bakmadan hepsini göster
    const hasPOStatusAllPermission = this.hasPOStatusAllPermission();
    if (!hasPOStatusAllPermission) {
      // All yetkisi yoksa diğerlerinden hangi yetkileri var onlar çekilir ve filtreye eklenir.
      const prefix = "PO_Status";

      // All yetkisi hariç diğer yetkileri çekiyoruz
      const filteredUserPerms = useAuthAppStore().getParsedToken?.perms?.filter(
        (permission) =>
          permission.startsWith(prefix) && !permission.includes("All")
      );

      if (filteredUserPerms.length > 0) {
        // Dinamik filtre oluşturma
        const dynamicFilter = filteredUserPerms.reduce(
          (acc, permission, index) => {
            const condition = ["Status", "=", permission.split(".")[1]]; // Tek tek filtreyi oluştur
            if (index === 0) {
              // İlk eleman için sadece koşulu ekle
              return condition;
            } else {
              // Diğer elemanlar için "or" ile birleştir
              return [acc, "or", condition];
            }
          },
          []
        );

        // Mevcut filtreye dinamik filtreyi ekle
        if (currentFilter.length > 0) {
          currentFilter.push("and", [dynamicFilter]);
        } else {
          currentFilter = [dynamicFilter];
        }
      } else {
        // Eğer filtre yoksa varsayılan bir filtre ekle
        if (currentFilter.length > 0) {
          currentFilter.push("and", ["Status", "=", ""]);
        } else {
          currentFilter.push(["Status", "=", ""]);
        }

        //All yoktu başka bir filtre de yok
        return {
          stopped: true,
          params: null,
        };
      }
    }

    // Status ve searchQuery kontrolü
    if (
      status ||
      params.searchQuery ||
      departmentQuery ||
      priority ||
      assignedUser ||
      terminal
    ) {
      if (status) {
        if (currentFilter.length > 0) {
          currentFilter.push("and", ["Status", "Contains", status]);
        } else {
          currentFilter.push(["Status", "Contains", status]);
        }
      }

      if (departmentQuery) {
        if (currentFilter.length > 0) {
          currentFilter.push("and", [
            "Department",
            "contains",
            departmentQuery,
          ]);
        } else {
          currentFilter.push(["Department", "contains", departmentQuery]);
        }
      }

      if (priority) {
        if (currentFilter.length > 0) {
          currentFilter.push("and", ["UsagePurpose", "contains", priority]);
        } else {
          currentFilter.push(["UsagePurpose", "contains", priority]);
        }
      }

      if (assignedUser) {
        if (currentFilter.length > 0) {
          currentFilter.push("and", ["AssignedUser", "contains", assignedUser]);
        } else {
          currentFilter.push(["AssignedUser", "contains", assignedUser]);
        }
      }

      // if (params.searchQuery) {
      //   if (currentFilter.length > 0) {
      //     currentFilter.push("and", [
      //       ["Number", "contains", params.searchQuery],
      //       "or",
      //       ["PurchaseRequestNumber", "contains", params.searchQuery],
      //     ]);
      //   } else {
      //     currentFilter.push([
      //       ["Number", "contains", params.searchQuery],
      //       "or",
      //       ["PurchaseRequestNumber", "contains", params.searchQuery],
      //     ]);
      //   }
      // }

      if (terminal && terminal.length > 0) {
        let orFilter = [];

        terminal.forEach((t, index) => {
          if (index > 0) {
            orFilter.push("or");
          }
          orFilter.push(["ComplexCode", "contains", t]);
        });

        if (currentFilter.length > 0) {
          currentFilter.push("and", orFilter);
        } else {
          currentFilter.push(orFilter);
        }
      }

      // searchQuery araması backend tarafında SearchQuery parametresi ile yapılıyor.
      // Backend, Number, PurchaseRequestNumber, SupplierName, Creator ve item Code/Name alanlarında parametreli sorgu ile arar.

      if (params.dateFrom) {
        const dateFilter = ["Created", ">=", params.dateFrom];
        currentFilter.length > 0 ? currentFilter.push("and", dateFilter) : currentFilter.push(dateFilter);
      }
      if (params.dateTo) {
        const dateFilter = ["Created", "<=", params.dateTo + "T23:59:59"];
        currentFilter.length > 0 ? currentFilter.push("and", dateFilter) : currentFilter.push(dateFilter);
      }
    }

    params.filter = JSON.stringify(currentFilter);
    return {
      stopped: false,
      params: params,
    };
  }

  async setDownloadAllFiles({ purchaseOrderServiceClient, params }) {
    var response = await purchaseOrderServiceClient.post({
      route: "/purchase-order/download-all-files",
      data: params,
      headers: {
        "X-YPH-COMPLEX": useAuthAppStore()?.getSelectedComplex,
        Authorization: `Bearer ${useAuthAppStore().token}`,
      },
      successCallback: function (resp) {
        // if (resp.data.length > 0)
        //     _selectedJob.unitsOnTruck = resp.data;
      },
      errorCallback: function (resp) {},
    });

    return response;
  }

  // bu method onay süresi tamamlandım purchase request i order a çevirir
  async setCreateEntity({ purchaseOrderServiceClient, params }) {
    //beklenen params bu şekilde
    // params : {
    //   "PurchaseRequestPKey": 0,
    //   "StagePKey": 0,
    //   "Status": "string"
    // }

    var response = await purchaseOrderServiceClient.post({
      route: "/purchase-order/create-entity",
      data: params,
      headers: {
        "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
        Authorization: `Bearer ${useAuthAppStore().token}`,
      },
      successCallback: function (resp) {
        // console.log("PO resp", resp);
        // if (resp.data.length > 0)
        //     _selectedJob.unitsOnTruck = resp.data;
      },
      errorCallback: function (resp) {},
    });

    return response;
  }

  async setSendToCancel({ purchaseOrderServiceClient, params }) {
    var response = await purchaseOrderServiceClient.put({
      route: "purchase-order/update-status",
      params: params,
      headers: {
        "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
        Authorization: `Bearer ${useAuthAppStore().token}`,
      },
      successCallback: function (resp) {},
      errorCallback: function (errorResp) {},
    });

    return response;
  }

  async setSupplierDeliveryStatus({ purchaseOrderServiceClient, params }) {
    // params: { PKey: number, SupplierDeliveryStatus: "NotSent" | "Sent" }
    var response = await purchaseOrderServiceClient.put({
      route: "purchase-order/update-supplier-delivery-status",
      params: params,
      headers: {
        "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
        Authorization: `Bearer ${useAuthAppStore().token}`,
      },
      successCallback: function (resp) {},
      errorCallback: function (errorResp) {},
    });

    return response;
  }

  // [Route("/purchase-order/find-by-request-number", "GET")]
  // public class FindPurchaseOrderByRequestNumber : IReturn<PointResponse<PurchaseOrder>>
  // {
  //     public string Number { get; set; }

  // }
  async getFindByRequestNumber({ purchaseOrderServiceClient, params }) {
    var response = await purchaseOrderServiceClient.get({
      route: "/purchase-order/find-by-request-number",
      params: params,
      headers: {
        "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex ?? 1100,
        Authorization: `Bearer ${useAuthAppStore().token}`,
      },
      successCallback: function (resp) {
        // console.log("resp", resp);
        // if (resp.data.length > 0)
        //     _selectedJob.unitsOnTruck = resp.data;
      },
      errorCallback: function (resp) {},
    });

    return response;
  }

  //   [Route("/purchase-order/find-by-request-numbers", "GET")]
  // public class FindPurchaseOrdersByRequestNumber : IReturn<PointResponse<List<PurchaseOrder>>>
  // {
  //     public string[] Numbers { get; set; }

  // }
  async getFindByRequestNumbers({ purchaseOrderServiceClient, params }) {
    var response = await purchaseOrderServiceClient.get({
      route: "/purchase-order/find-by-request-numbers",
      params: params,
      headers: {
        "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex ?? 1100,
        Authorization: `Bearer ${useAuthAppStore().token}`,
      },
      successCallback: function (resp) {
        // console.log("resp", resp);
        // if (resp.data.length > 0)
        //     _selectedJob.unitsOnTruck = resp.data;
      },
      errorCallback: function (resp) {},
    });

    return response;
  }

  async getPurchaseOrderItemCreatedItemsByRequestNumber({
    purchaseOrderServiceClient,
    params,
  }) {
    var response = await purchaseOrderServiceClient.get({
      route: "/purchase-order-item/get-created-items-by-pr-number",
      params: params,
      headers: {
        "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex ?? 1100,
        Authorization: `Bearer ${useAuthAppStore().token}`,
      },
      successCallback: function (resp) {
        // console.log("resp", resp);
        // if (resp.data.length > 0)
        //     _selectedJob.unitsOnTruck = resp.data;
      },
      errorCallback: function (resp) {},
    });

    return response;
  }

  async getPurchaseOrderItemCreatedItemsByRequestNumbers({
    purchaseOrderServiceClient,
    params,
  }) {
    var response = await purchaseOrderServiceClient.get({
      // route: "/purchase-order-item/get-purchase-order-item-created-items-by-request-numbers",
      route: "/purchase-order-item/get-created-items-by-pr-numbers",
      params: params,
      headers: {
        "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
        Authorization: `Bearer ${useAuthAppStore().token}`,
      },
      successCallback: function (resp) {
        // console.log("resp", resp);
        // if (resp.data.length > 0)
        //     _selectedJob.unitsOnTruck = resp.data;
      },
      errorCallback: function (resp) {},
    });

    return response;
  }

  // bu method onay maili giden kullanıcıların onaylamasını veya iptal etmesini sağlar
  async getStatsByApprover({ purchaseOrderServiceClient }) {
    var response = await purchaseOrderServiceClient.get({
      route: "/purchase-order/stats-by-approver",
      headers: {
        "X-YPH-COMPLEX": useAuthAppStore()?.getSelectedComplex,
        Authorization: `Bearer ${useAuthAppStore().token}`,
      },
      successCallback: function (resp) {
        // if (resp.data.length > 0)
        //     _selectedJob.unitsOnTruck = resp.data;
      },
      errorCallback: function (resp) {},
    });

    return response;
  }

  async sendPurchaseOrderItemReceiptsCreateEntity({
    purchaseOrderServiceClient,
    params,
  }) {
    // console.log("sendReceivedDate e girdi....", params);

    var response = await purchaseOrderServiceClient.post({
      route: "/purchase-order-item-receipts/create-entity",
      data: params,
      headers: {
        "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
        Authorization: `Bearer ${useAuthAppStore().token}`,
      },
      successCallback: function (resp) {},
      errorCallback: function (resp) {},
    });

    return response;
  }

  async closePurchaseOrderItem({ purchaseOrderServiceClient, params }) {
    var response = await purchaseOrderServiceClient.post({
      route: "/purchase-order-item-receipts/close-item",
      data: params,
      headers: {
        "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
        Authorization: `Bearer ${useAuthAppStore().token}`,
      },
      successCallback: function (resp) {},
      errorCallback: function (resp) {},
    });

    return response;
  }

  hasPOReadAllPermission() {
    var userStore = useAuthAppStore();
    let userPerms = userStore.getParsedToken?.perms;
    let permissionService = new PermissionService();

    if (!Array.isArray(userPerms)) {
      return false;
    }

    //return userPerms.includes(`${complexService.getInfoByCode(userStore.getSelectedComplex)?.description}.${permissionEnum.PurchaseOrderReadAll}`);
    return permissionService.checkPermissionsForOperations(
      permissionEnum.PurchaseOrderReadAll
    );
  }
  hasPOStatusAllPermission() {
    var userPerms = useAuthAppStore().getParsedToken?.perms;
    let permissionService = new PermissionService();

    if (!Array.isArray(userPerms)) {
      return false;
    }

    return permissionService.checkPermissionsForOperations(
      permissionEnum.POStatusAll
    );
  }

  // bu method onay maili giden kullanıcıların onaylamasını veya iptal etmesini sağlar
  async setStageStatus({ purchaseOrderServiceClient, params }) {
    var response = await purchaseOrderServiceClient.post({
      route: "/purchase-order/set-stage-status",
      data: params,
      headers: {
        "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex ?? 1100,
        Authorization: `Bearer ${useAuthAppStore().token}`,
      },
      successCallback: function (resp) {
        // if (resp.data.length > 0)
        //     _selectedJob.unitsOnTruck = resp.data;
      },
      errorCallback: function (resp) {},
    });

    return response;
  }

  async getEntityByPkey({ purchaseOrderServiceClient, params }) {
    var response = await purchaseOrderServiceClient.get({
      route: "/purchase-order/get-entity-by-pkey",
      params: params,
      headers: {
        "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex ?? 1100,
        Authorization: `Bearer ${useAuthAppStore().token}`,
      },
      successCallback: function (resp) {
        // if (resp.data.length > 0)
        //     _selectedJob.unitsOnTruck = resp.data;
      },
      errorCallback: function (resp) {},
    });

    return response;
  }

  // PO'nun (header + kalemleri) tüm edit geçmişini point.Audit'ten okur.
  // params: { PKey }
  async getChangeHistory({ purchaseOrderServiceClient, params }) {
    var response = await purchaseOrderServiceClient.get({
      route: "/purchase-order/get-change-history",
      params: params,
      headers: {
        "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex ?? 1100,
        Authorization: `Bearer ${useAuthAppStore().token}`,
      },
      successCallback: function (resp) {},
      errorCallback: function (resp) {},
    });

    return response;
  }

  // //confirm processini başlatır ve onaylama sürecindeki ilk kişiye onay maili gider.
  async sendToApprovers({ purchaseOrderServiceClient, params }) {
    //beklenen params bu şekilde
    // params : {
    //   "PKey": 0
    // }

    var response = await purchaseOrderServiceClient.post({
      route: "/purchase-order/send-to-approvers",
      data: params,
      headers: {
        "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex ?? 1100,
        Authorization: `Bearer ${useAuthAppStore().token}`,
      },
      successCallback: function (resp) {
        // if (resp.data.length > 0)
        //     _selectedJob.unitsOnTruck = resp.data;
      },
      errorCallback: function (resp) {},
    });

    return response;
  }

  // Mevcut bekleyen onaycıya onay mailini yeniden gönderir. Matris/state değişmez.
  async resendApprovalEmail({ purchaseOrderServiceClient, params }) {
    let response;
    try {
      response = await purchaseOrderServiceClient.post({
        route: "/purchase-order/resend-approval-email",
        data: params,
        headers: {
          "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex ?? 1100,
          Authorization: `Bearer ${useAuthAppStore().token}`,
        },
      });
    }
    catch (error) {
      console.error("error", error);
      response = error.response ?? error;
    }
    return response;
  }

  async updateCurrencyRates({ purchaseOrderServiceClient, params }) {
    //beklenen params bu şekilde
    // params : {
    //   "PKey": 0
    // }

    var response = await purchaseOrderServiceClient.post({
      route: "/purchase-order/update-currency-rates",
      data: params,
      headers: {
        "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex ?? 1100,
        Authorization: `Bearer ${useAuthAppStore().token}`,
      },
      successCallback: function (resp) {
        // if (resp.data.length > 0)
        //     _selectedJob.unitsOnTruck = resp.data;
      },
      errorCallback: function (resp) {},
    });

    return response;
  }

  async getPurchaseOrderItemReceiptsFindByPoNumbers({
    purchaseOrderServiceClient,
    params,
  }) {
    var response = await purchaseOrderServiceClient.post({
      route: "/purchase-order-item-receipts/find-by-po-numbers",
      data: params,
      headers: {
        "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex ?? 1100,
        Authorization: `Bearer ${useAuthAppStore().token}`,
      },
      successCallback: function (resp) {
        // if (resp.data.length > 0)
        //     _selectedJob.unitsOnTruck = resp.data;
      },
      errorCallback: function (resp) {},
    });

    return response;
  }

  async findPurchaseOrderByApprover({
    purchaseOrderServiceClient,
    searchQuery,
    params,
    assingStatus,
    priority,
    assignedUser,
    departmentQuery,
    terminal,
  }) {
    var resp = this.getFiltersByUserPermissions(
      params,
      status,
      departmentQuery,
      priority,
      assignedUser,
      terminal
    );
    console.log("resp---------------------->", resp);

    // let currentFilter = JSON.parse(params.filter || "[]");

    // if (params.searchQuery) {
    //   if (currentFilter.length > 0) {
    //     currentFilter.push("and", [
    //       ["Number", "contains", params.searchQuery],
    //       "or",
    //       ["PurchaseRequestNumber", "contains", params.searchQuery],
    //     ]);
    //   } else {
    //     currentFilter.push([
    //       ["Number", "contains", params.searchQuery],
    //       "or",
    //       ["PurchaseRequestNumber", "contains", params.searchQuery],
    //     ]);
    //   }
    // }

    // if (params.searchQuery) {
    //   const searchFilter = [
    //     ["Number", "contains", params.searchQuery],
    //     "or",
    //     ["PurchaseRequestNumber", "contains", params.searchQuery],
    //     "or",
    //     ["SupplierName", "contains", params.searchQuery],
    //     "or",
    //     ["Creator", "contains", params.searchQuery],
    //   ];

    //   if (currentFilter.length > 0) {
    //     currentFilter.push("and", searchFilter);
    //   } else {
    //     currentFilter.push(searchFilter);
    //   }
    // }

    // params.filter = JSON.stringify(currentFilter);

    var response = await purchaseOrderServiceClient.get({
      route: "/purchase-order/find-by-approver",
      params: params,
      headers: {
        "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
        Authorization: `Bearer ${useAuthAppStore().token}`,
      },
      successCallback: function (resp) {
        // if (resp.data.length > 0)
        //     _selectedJob.unitsOnTruck = resp.data;
      },
      errorCallback: function (resp) {},
    });

    return response;
  }

  async setExport({ client, params }) {
    var response = await client.get({
      route: "/purchase-order/download-entities",
      params: params,
      headers: {
        "X-YPH-COMPLEX": useAuthAppStore().getSelectedComplex,
        "Content-Type": "application/json",
        Authorization: `Bearer ${useAuthAppStore().token}`,
      },
    });
    return response;
  }
}
